import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray } from '@angular/forms';

@Injectable({ providedIn: "root" })
export class FormTouchUtil {

  /**
   * Vynutí revalidaci všech prvků formuláře a označí je jako "touched", čímž dojde k zobrazení validačních chyb
   * Inspirace: https://loiane.com/2017/08/angular-reactive-forms-trigger-validation-on-submit/
   * @param formGroup
   * @param emitEvent - výchozí true (původní chování). Revalidace i markAsTouched proběhnou vždy
   * bez ohledu na tento parametr - řídí jen to, zda se navíc znovu spustí valueChanges posluchače
   * jednotlivých polí (jako by je uživatel právě přepsal). Formuláře, jejichž posluchače na
   * valueChanges mají side efekty nežádoucí při pouhém "touchnutí" před odesláním (např. dohledání
   * dodavatele/POP dle ČJR ve FormInfDokladVyvozComponent), volají s false.
   */
  touchAllFormFields(formGroup: UntypedFormGroup | UntypedFormArray, emitEvent: boolean = true) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.updateValueAndValidity({ onlySelf: true, emitEvent });
        control.markAsTouched({ onlySelf: true });
      }
      else if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
        this.touchAllFormFields(control, emitEvent);
        control.updateValueAndValidity({ onlySelf: true, emitEvent });
        control.markAllAsTouched();
      }
    });
  }
}
